module.exports = {"introText":"xxx","firstBoxHeader":"Moderne","firstBoxText":"xxx","secondBoxHeader":"Sikkert","secondBoxText":"xxx","thirdBoxHeader":"Skalerbart","thirdBoxText":"xxx","localizationHeader":"Lokalisering","localizationFirst":"xxx","localizationSecond":"xxx","errorhandlingHeader":"Fejlhåndtering","errorhandlingFirst":"xxx","compatibilityHeader":"Kompatibilitet","compatibilityFirst":"xxx"}


//////////////////
// WEBPACK FOOTER
// ./src/app/core/lang/da.lang.json
// module id = 337
// module chunks = 1